import { Store } from 'vuex'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.FunnelCreated',
    callback: (funnel: KwixeoOpportunities.Funnel): void => {
      store.dispatch('opportunities/setFunnel', funnel)
    }
  },
  {
    name: '.FunnelUpdated',
    callback: (funnel: KwixeoOpportunities.Funnel): void => {
      store.dispatch('opportunities/setFunnel', funnel)
    }
  },
  {
    name: '.FunnelDeleted',
    callback: (funnel: KwixeoOpportunities.Funnel): void => {
      store.dispatch('opportunities/deleteFunnel', funnel)
    }
  }
])
